import React from "react";
import Pill from "./PillElement";
import { PhosphorWarningCircle } from "components/Atoms/PhosphorIcon";

interface WarningPillProps {
  label: string;
  onClick?: () => void;
}

export const WarningPill = ({ label, onClick }: WarningPillProps) => {
  return <Pill
    color="transparent"
    title={label}
    onClick={onClick}
    label={<div className="flex gap-small align-center">
      <div style={{ height: 14 }}>
        <PhosphorWarningCircle iconSize="small" iconColor="yellow" />
      </div>
      {label}
    </div>}
  />
}